var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('mpx-view',{staticClass:"swipe-item",style:(_vm._f("transRpxStyle")([(_vm.itemStyle)])),on:{"tap":_vm.handleClick}},[_c('div',{staticClass:"image",style:(_vm._f("transRpxStyle")([("backgroundImage : url("+(_vm.item)+")"),(_vm.imageStyle)]))})])
}
var staticRenderFns = []

export { render, staticRenderFns }